// import { useState, useCallback, useRef } from "react";
// import { ShoppingCart, Check, Eye, TrendingUp, Trophy } from "lucide-react";
// import { useTopSellers } from "../../hooks/useTopSellers";
// import "./BestSellingSlider.scss";
// import { useNavigate } from "react-router-dom";
// import { getLanguage } from "../../utils/Helper";
// import { useCart } from "../../context/CartContext";
// import { toast } from "react-toastify";
// import WishlistButton from "../general/wishlistButton/WishlistButton";

// const BestSellingSlider = () => {
//   const [isAddingToCart, setIsAddingToCart] = useState({});
//   const [showSuccess, setShowSuccess] = useState({});
//   const containerRef = useRef(null);

//   const navigate = useNavigate();
//   const lang = getLanguage();

//   const { topSellers: products, loading, error } = useTopSellers();
//   const { addToCart, removeFromCart, isInCart } = useCart();

//   // ─── Navigation ───────────────────────────────────────
//   const scrollToDirection = (direction) => {
//     const container = containerRef.current;
//     if (!container) return;
//     const scrollAmount = container.clientWidth * 0.8;
//     const newPosition =
//       direction === "left"
//         ? container.scrollLeft - scrollAmount
//         : container.scrollLeft + scrollAmount;
//     container.scrollTo({ left: newPosition, behavior: "smooth" });
//   };

//   const handlePrevious = () => scrollToDirection("left");
//   const handleNext = () => scrollToDirection("right");

//   // ─── Product profile URL ──────────────────────────────
//   // topSellers uses collectionNameUrl / categoryNameUrl / subCategoryNameUrl
//   const openProductProfile = (product) => {
//     const collectionName = product.collectionNameUrl
//       .toString().toLowerCase().trim().split(" ").join("-");
//     const catName = product.categoryNameUrl
//       .toString().toLowerCase().trim().split(" ").join("-");
//     const subCatName = product.subCategoryNameUrl
//       .toString().toLowerCase().trim().split(" ").join("-");
//     navigate(`/collection/${collectionName}/${catName}/${subCatName}/${product.id}`);
//   };

//   // ─── Description truncate ────────────────────────────
//   const handleProductDesc = (desc) =>
//     desc?.length > 100 ? `${desc.substring(0, 100)}...` : desc;

//   // ─── Colors من variants ───────────────────────────────
//   const getUniqueColors = (product) => {
//     if (!product.variants || product.variants.length === 0) return [];
//     const colors = product.variants
//       .map((v) => v.color)
//       .filter((col) => col && col.hexCode);
//     return colors.filter(
//       (color, index, self) =>
//         index === self.findIndex((c) => c.hexCode === color.hexCode)
//     );
//   };

//   const getAvailableVariant = (product) => {
//     if (!product.variants || product.variants.length === 0) return null;
//     return (
//       product.variants.find((v) => {
//         return (
//           v.isActive &&
//           ((v.quantity - v.reservedQuantity > 0) ||
//             (v.withoutBoxQuantity - v.withoutBoxReservedQuantity > 0))
//         );
//       }) || product.variants[0]
//     );
//   };

//   const isOutOfStock = (product) => {
//     if (!product.variants || product.variants.length === 0) return true;
//     return !product.variants.some(
//       (v) =>
//         v.isActive &&
//         ((v.quantity - v.reservedQuantity > 0) ||
//           (v.withoutBoxQuantity - v.withoutBoxReservedQuantity > 0))
//     );
//   };

//   // ─── Cart Action ──────────────────────────────────────
//   const handleCartAction = useCallback(
//     async (e, product) => {
//       e.preventDefault();
//       e.stopPropagation();

//       const variant = getAvailableVariant(product);
//       if (!variant || isAddingToCart[product.id] || isOutOfStock(product)) return;

//       const isWithoutBox = (variant.quantity - variant.reservedQuantity) <= 0;
//       const productInCart = isInCart(variant.id, isWithoutBox);

//       if (productInCart) {
//         setIsAddingToCart((prev) => ({ ...prev, [product.id]: true }));
//         try {
//           await removeFromCart(product.id, variant.id, isWithoutBox);
//           toast.success(
//             lang === "EN" ? "Removed from cart!" : "تم الحذف من السلة!",
//             { position: lang === "AR" ? "top-right" : "top-left", autoClose: 2000 }
//           );
//         } catch {
//           toast.error(lang === "EN" ? "Error removing from cart" : "خطأ في حذف المنتج");
//         } finally {
//           setIsAddingToCart((prev) => ({ ...prev, [product.id]: false }));
//         }
//       } else {
//         setIsAddingToCart((prev) => ({ ...prev, [product.id]: true }));
//         setShowSuccess((prev) => ({ ...prev, [product.id]: false }));
//         try {
//           const cartProduct = {
//             id: product.id,
//             nameEn: product.nameEn,
//             nameAr: product.nameAr,
//             descriptionEn: product.descriptionEn,
//             descriptionAr: product.descriptionAr,
//             images: [{ image_url: product.imageUrl }],
//             brand: { nameEn: product.brandNameEn, nameAr: product.brandNameAr },
//             collection: { nameEn: product.collectionNameUrl },
//             category: { nameEn: product.categoryNameUrl },
//             subCategory: { nameEn: product.subCategoryNameUrl },
//           };
//           const cartVariant = {
//             id: variant.id,
//             price: variant.price,
//             discountPrice: variant.discountPrice || null,
//             quantity: variant.quantity - variant.reservedQuantity || 0,
//             withoutBoxQuantity:
//               variant.withoutBoxQuantity - variant.withoutBoxReservedQuantity || 0,
//             color: variant.color || null,
//             size: variant.size || null,
//             sku: variant.sku || "",
//           };
//           await addToCart(cartProduct, cartVariant, 1, isWithoutBox, false);
//         } catch {
//           toast.error(
//             lang === "EN"
//               ? "Something went wrong while adding to cart"
//               : "حدث خطأ أثناء إضافة المنتج للسلة"
//           );
//         } finally {
//           setIsAddingToCart((prev) => ({ ...prev, [product.id]: false }));
//         }
//       }
//     },
//     [isAddingToCart, addToCart, removeFromCart, isInCart, lang]
//   );

//   // ─── Product Card ─────────────────────────────────────
//   const ProductCard = ({ product, index }) => {
//     const uniqueColors = getUniqueColors(product);
//     const outOfStock = isOutOfStock(product);
//     const availableVariant = getAvailableVariant(product);

//     const isWithoutBox = availableVariant
//       ? (availableVariant.quantity - availableVariant.reservedQuantity) <= 0
//       : false;
//     const productInCart = availableVariant
//       ? isInCart(availableVariant.id, isWithoutBox)
//       : false;

//     return (
//       <div
//         className="bs-product-card"
//         onClick={() => openProductProfile(product)}
//         style={{ animationDelay: `${index * 0.1}s` }}
//       >
//         {/* Image */}
//         <div className="bs-card-image-wrapper">
//           {/* Best Seller Badge */}
//           <div className="bs-trending-badge">
//             <Trophy size={14} fill="currentColor" />
//             <span>{lang === "EN" ? "Best Seller" : "الأكثر مبيعاً"}</span>
//           </div>

//           {/* Wishlist */}
//           {availableVariant && (
//             <div
//               className="bs-wishlist-wrapper"
//               onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}
//             >
//               <WishlistButton
//                 productVariantId={availableVariant.id}
//                 className="bs-wishlist-btn"
//               />
//             </div>
//           )}

//           {/* Discount Badge */}
//           {product.discountPrice && product.discountPrice !== product.price && (
//             <div className="bs-discount-badge">
//               -{Math.round(((product.price - product.discountPrice) / product.price) * 100)}%
//             </div>
//           )}

//           {/* Out of Stock */}
//           {outOfStock && (
//             <div className="bs-out-of-stock-overlay">
//               <span>{lang === "EN" ? "Out of Stock" : "غير متوفر"}</span>
//             </div>
//           )}

//           <img
//             src={product.imageUrl}
//             alt={lang === "EN" ? product.nameEn : product.nameAr}
//             className="bs-card-image"
//           />
//         </div>

//         {/* Content */}
//         <div className="bs-card-content">
//           {product.brandImageUrl && (
//             <div className="bs-brand-logo">
//               <img
//                 src={product.brandImageUrl}
//                 alt={lang === "EN" ? product.brandNameEn : product.brandNameAr}
//               />
//             </div>
//           )}

//           <div className="bs-category">
//             {lang === "EN" ? product.categoryNameUrl : product.categoryNameAr}
//           </div>

//           <h3 className="bs-product-title">
//             {lang === "EN" ? product.nameEn : product.nameAr}
//           </h3>

//           {(product.descriptionEn || product.descriptionAr) && (
//             <p className="bs-product-description">
//               {lang === "EN"
//                 ? handleProductDesc(product.descriptionEn)
//                 : handleProductDesc(product.descriptionAr)}
//             </p>
//           )}

//           {uniqueColors.length > 0 && (
//             <div className="bs-colors-section">
//               <div className="bs-colors-list">
//                 {uniqueColors.slice(0, 5).map((color, idx) => (
//                   <div
//                     key={idx}
//                     className="bs-color-dot"
//                     style={{ backgroundColor: color.hexCode, color: color.hexCode }}
//                     title={lang === "EN" ? color.nameEn : color.nameAr}
//                   />
//                 ))}
//                 {uniqueColors.length > 5 && (
//                   <div className="bs-more-colors">+{uniqueColors.length - 5}</div>
//                 )}
//               </div>
//             </div>
//           )}

//           <div className="bs-price-section">
//             <div className="bs-price-main">
//               {(product.discountPrice || product.price).toLocaleString()}
//               <span className="bs-currency">{lang === "EN" ? "EGP" : "ج.م"}</span>
//             </div>
//             {product.discountPrice && product.discountPrice !== product.price && (
//               <div className="bs-price-old">
//                 {product.price.toLocaleString()} {lang === "EN" ? "EGP" : "ج.م"}
//               </div>
//             )}
//           </div>

//           <div className="bs-card-actions">
//             <button className={`bs-btn-add-cart
//                 ${productInCart ? "in-cart" : ""}
//                 ${showSuccess[product.id] ? "success" : ""}
//                 ${isAddingToCart[product.id] ? "loading" : ""}
//                 ${outOfStock ? "out-of-stock" : ""}`}
//               onClick={(e) => handleCartAction(e, product)}
//               disabled={isAddingToCart[product.id] || outOfStock}
//             >
//               {showSuccess[product.id] ? (
//                 <><Check size={18} strokeWidth={2.5} /><span>{lang === "EN" ? "Added!" : "تمت!"}</span></>
//               ) : isAddingToCart[product.id] ? (
//                 <><div className="bs-btn-spinner"></div><span>{lang === "EN" ? "Processing..." : "جاري..."}</span></>
//               ) : outOfStock ? (
//                 <span>{lang === "EN" ? "Out of Stock" : "غير متوفر"}</span>
//               ) : productInCart ? (
//                 <><ShoppingCart size={18} strokeWidth={2.5} /><span>{lang === "EN" ? "Remove from cart" : "إزالة من السلة"}</span></>
//               ) : (
//                 <><ShoppingCart size={18} strokeWidth={2.5} /><span>{lang === "EN" ? "Add to Cart" : "أضف للسلة"}</span></>
//               )}
//             </button>

//             <button
//               className="bs-btn-view"
//               onClick={(e) => { e.stopPropagation(); openProductProfile(product); }}
//             >
//               <Eye size={18} strokeWidth={2.5} />
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   // ─── Loading ──────────────────────────────────────────
//   if (loading) {
//     return (
//       <div className="best-selling-slider">
//         <div className="bs-loading">
//           <div className="bs-loading-content">
//             <div className="bs-spinner"></div>
//             <p>{lang === "EN" ? "Loading Best Sellers..." : "جاري تحميل الأكثر مبيعاً..."}</p>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   if (error || !products || products.length === 0) {
//     return (
//       <div className="best-selling-slider">
//         <div className="bs-loading">
//           <p>{lang === "EN" ? "No best sellers available" : "لا توجد منتجات متاحة"}</p>
//         </div>
//       </div>
//     );
//   }

//   // ─── Render ───────────────────────────────────────────
//   const duplicatedProducts = [...products, ...products];

//   return (
//     <div className="best-selling-slider" style={{backgroundImage: "url('/assets/yellow background.jpg')"}}>

//       {/* Header */}
//       <div className="bs-slider-header">
//         <div className="bs-title-section">
//           <TrendingUp className="bs-icon" size={36} strokeWidth={2.5} style={{ color: "rgba(26, 26, 26, 0.95)" }} />
//           <h2 className="bs-slider-title" style={{ color: "rgba(26, 26, 26, 0.95)" }}>
//             {lang === "EN" ? "Top Most Sold" : "المنتجات الأكثر مبيعاً"}
//           </h2>
//           <Trophy className="bs-icon" size={36} strokeWidth={2.5} style={{ color: "rgba(26, 26, 26, 0.95)" }} />
//         </div>
//       </div>

//       {/* Slider */}
//       <div className="bs-slider-wrapper">
//         <button
//           className="bs-nav-button bs-nav-left"
//           onClick={handlePrevious}
//           aria-label={lang === "EN" ? "Previous" : "السابق"}
//         >
//           <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
//             stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
//             <polyline points="15 18 9 12 15 6"></polyline>
//           </svg>
//         </button>

//         <div className="bs-cards-container" ref={containerRef}>
//           <div className="bs-cards-wrapper">
//             {duplicatedProducts.map((product, index) => (
//               <ProductCard key={`bs-product-${index}`} product={product} index={index} />
//             ))}
//           </div>
//         </div>

//         <button
//           className="bs-nav-button bs-nav-right"
//           onClick={handleNext}
//           aria-label={lang === "EN" ? "Next" : "التالي"}
//         >
//           <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
//             stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
//             <polyline points="9 18 15 12 9 6"></polyline>
//           </svg>
//         </button>
//       </div>
//     </div>
//   );
// };

// export default BestSellingSlider;

import { useState, useCallback, useEffect, useRef } from "react";
import { ShoppingCart, Check, Eye, TrendingUp, Trophy, ChevronLeft, ChevronRight } from "lucide-react";
import { useTopSellers } from "../../hooks/useTopSellers";
import "./BestSellingSlider.scss";
import { useNavigate } from "react-router-dom";
import { getLanguage } from "../../utils/Helper";
import { useCart } from "../../context/CartContext";
import { toast } from "react-toastify";
import WishlistButton from "../general/wishlistButton/WishlistButton";

const BestSellingSlider = () => {
  const [isAddingToCart, setIsAddingToCart] = useState({});
  const [showSuccess, ]       = useState({});
  const [canScrollLeft, setCanScrollLeft]   = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  const containerRef = useRef(null);
  const navigate     = useNavigate();
  const lang         = getLanguage();

  const { topSellers: products, loading, error } = useTopSellers();
  const { addToCart, removeFromCart, isInCart }  = useCart();

  // ─── Scroll arrows visibility ─────────────────────────
  const checkScroll = () => {
    const el = containerRef.current;
    if (!el) return;
    setCanScrollLeft(el.scrollLeft > 4);
    setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 4);
  };

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    checkScroll();
    el.addEventListener("scroll", checkScroll, { passive: true });
    const ro = new ResizeObserver(checkScroll);
    ro.observe(el);
    return () => { el.removeEventListener("scroll", checkScroll); ro.disconnect(); };
  }, [products]);

  const scroll = (dir) => {
    const el = containerRef.current;
    if (!el) return;
    el.scrollBy({ left: dir === "right" ? el.clientWidth * 0.75 : -(el.clientWidth * 0.75), behavior: "smooth" });
  };

  // ─── Helpers ──────────────────────────────────────────
  const openProductProfile = (product) => {
    const slug = (s) => s.toString().toLowerCase().trim().split(" ").join("-");
    navigate(`/collection/${slug(product.collectionNameUrl)}/${slug(product.categoryNameUrl)}/${slug(product.subCategoryNameUrl)}/${product.id}`);
  };

  const truncate = (text, max = 80) =>
    text?.length > max ? `${text.substring(0, max)}...` : text ?? "";

  const getUniqueColors = (product) => {
    if (!product.variants?.length) return [];
    const seen = new Set();
    return product.variants
      .map((v) => v.color)
      .filter((c) => c?.hexCode && !seen.has(c.hexCode) && seen.add(c.hexCode));
  };

  const getAvailableVariant = (product) =>
    product.variants?.find(
      (v) => v.isActive &&
        ((v.quantity - v.reservedQuantity > 0) ||
          (v.withoutBoxQuantity - v.withoutBoxReservedQuantity > 0))
    ) ?? product.variants?.[0] ?? null;

  const isOutOfStock = (product) =>
    !product.variants?.some(
      (v) => v.isActive &&
        ((v.quantity - v.reservedQuantity > 0) ||
          (v.withoutBoxQuantity - v.withoutBoxReservedQuantity > 0))
    );

  // ─── Cart action ──────────────────────────────────────
  const handleCartAction = useCallback(async (e, product) => {
    e.preventDefault();
    e.stopPropagation();
    const variant = getAvailableVariant(product);
    if (!variant || isAddingToCart[product.id] || isOutOfStock(product)) return;

    const isWithoutBox  = (variant.quantity - variant.reservedQuantity) <= 0;
    const productInCart = isInCart(variant.id, isWithoutBox);

    setIsAddingToCart((p) => ({ ...p, [product.id]: true }));
    try {
      if (productInCart) {
        await removeFromCart(product.id, variant.id, isWithoutBox);
        // toast.success(lang === "EN" ? "Removed from cart!" : "تم الحذف من السلة!", {
        //   position: lang === "AR" ? "top-right" : "top-left", autoClose: 2000,
        // });
      } else {
        const cartProduct = {
          id: product.id,
          nameEn: product.nameEn, nameAr: product.nameAr,
          descriptionEn: product.descriptionEn, descriptionAr: product.descriptionAr,
          images: [{ image_url: product.imageUrl }],
          brand: { nameEn: product.brandNameEn, nameAr: product.brandNameAr },
          collection: { nameEn: product.collectionNameUrl },
          category: { nameEn: product.categoryNameUrl },
          subCategory: { nameEn: product.subCategoryNameUrl },
        };
        const cartVariant = {
          id: variant.id,
          price: variant.price,
          discountPrice: variant.discountPrice ?? null,
          quantity: (variant.quantity - variant.reservedQuantity) || 0,
          withoutBoxQuantity: (variant.withoutBoxQuantity - variant.withoutBoxReservedQuantity) || 0,
          color: variant.color ?? null,
          size: variant.size ?? null,
          sku: variant.sku ?? "",
        };
        await addToCart(cartProduct, cartVariant, 1, isWithoutBox, false);
      }
    } catch {
      toast.error(lang === "EN" ? "Something went wrong" : "حدث خطأ ما");
    } finally {
      setIsAddingToCart((p) => ({ ...p, [product.id]: false }));
    }
  }, [isAddingToCart, addToCart, removeFromCart, isInCart, lang]);

  // ─── Product Card ─────────────────────────────────────
  const ProductCard = ({ product }) => {
    const uniqueColors     = getUniqueColors(product);
    const outOfStock       = isOutOfStock(product);
    const availableVariant = getAvailableVariant(product);
    const isWithoutBox     = availableVariant
      ? (availableVariant.quantity - availableVariant.reservedQuantity) <= 0
      : false;
    const productInCart    = availableVariant ? isInCart(availableVariant.id, isWithoutBox) : false;
    const hasDiscount      = product.discountPrice && product.discountPrice !== product.price;
    const discountPct      = hasDiscount
      ? Math.round(((product.price - product.discountPrice) / product.price) * 100)
      : 0;

    return (
      <div className="bs-card" onClick={() => openProductProfile(product)}>

        {/* ── Image ── */}
        <div className="bs-card__img-wrap">
          <span className="bs-card__badge bs-card__badge--seller">
            <Trophy size={11} fill="currentColor" />
            {lang === "EN" ? "Best Seller" : "الأكثر مبيعاً"}
          </span>

          {hasDiscount && (
            <span className="bs-card__badge bs-card__badge--discount">-{discountPct}%</span>
          )}

          {outOfStock && (
            <div className="bs-card__oos">
              <span>{lang === "EN" ? "Out of Stock" : "غير متوفر"}</span>
            </div>
          )}

          {availableVariant && (
            <div className="bs-card__wishlist" onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
              <WishlistButton productVariantId={availableVariant.id} className="bs-card__wishlist-btn" />
            </div>
          )}

          <img
            src={product.imageUrl}
            alt={lang === "EN" ? product.nameEn : product.nameAr}
            className="bs-card__img"
          />
        </div>

        {/* ── Content ── */}
        <div className="bs-card__body">
          {product.brandImageUrl && (
            <img
              src={product.brandImageUrl}
              alt={lang === "EN" ? product.brandNameEn : product.brandNameAr}
              className="bs-card__brand-img"
            />
          )}

          <p className="bs-card__category">
            {lang === "EN" ? product.categoryNameUrl : product.categoryNameAr}
          </p>

          <h3 className="bs-card__name">
            {lang === "EN" ? product.nameEn : product.nameAr}
          </h3>

          {(product.descriptionEn || product.descriptionAr) && (
            <p className="bs-card__desc">
              {truncate(lang === "EN" ? product.descriptionEn : product.descriptionAr)}
            </p>
          )}

          {uniqueColors.length > 0 && (
            <div className="bs-card__colors">
              {uniqueColors.slice(0, 5).map((color, i) => (
                <span
                  key={i}
                  className="bs-card__color-dot"
                  style={{ backgroundColor: color.hexCode }}
                  title={lang === "EN" ? color.nameEn : color.nameAr}
                />
              ))}
              {uniqueColors.length > 5 && (
                <span className="bs-card__color-more">+{uniqueColors.length - 5}</span>
              )}
            </div>
          )}

          <div className="bs-card__price">
            <span className="bs-card__price-current">
              {(product.discountPrice || product.price).toLocaleString()}
              <span className="bs-card__price-currency">{lang === "EN" ? " EGP" : " ج.م"}</span>
            </span>
            {hasDiscount && (
              <span className="bs-card__price-old">
                {product.price.toLocaleString()} {lang === "EN" ? "EGP" : "ج.م"}
              </span>
            )}
          </div>

          <div className="bs-card__actions">
            <button
              className={[
                "bs-card__btn-cart",
                productInCart          ? "is-in-cart" : "",
                showSuccess[product.id]? "is-success"  : "",
                isAddingToCart[product.id] ? "is-loading" : "",
                outOfStock             ? "is-oos"     : "",
              ].filter(Boolean).join(" ")}
              onClick={(e) => handleCartAction(e, product)}
              disabled={isAddingToCart[product.id] || outOfStock}
            >
              {isAddingToCart[product.id] ? (
                <><div className="bs-btn-spinner" /><span>{lang === "EN" ? "Processing..." : "جاري..."}</span></>
              ) : showSuccess[product.id] ? (
                <><Check size={16} strokeWidth={2.5} /><span>{lang === "EN" ? "Added!" : "تمت!"}</span></>
              ) : outOfStock ? (
                <><ShoppingCart size={16} strokeWidth={2.5} /><span>{lang === "EN" ? "Out of Stock" : "غير متوفر"}</span></>
              ) : productInCart ? (
                <><ShoppingCart size={16} strokeWidth={2.5} /><span>{lang === "EN" ? "Remove" : "إزالة"}</span></>
              ) : (
                <><ShoppingCart size={16} strokeWidth={2.5} /><span>{lang === "EN" ? "Add to Cart" : "أضف للسلة"}</span></>
              )}
            </button>

            <button
              className="bs-card__btn-view"
              onClick={(e) => { e.stopPropagation(); openProductProfile(product); }}
              aria-label="View product"
            >
              <Eye size={16} strokeWidth={2.5} />
            </button>
          </div>
        </div>
      </div>
    );
  };

  // ─── Loading ──────────────────────────────────────────
  if (loading) {
    return (
      <div className="bs-slider bs-slider--loading" style={{ backgroundImage: "url('/assets/yellow background.jpg')" }}>
        <div className="bs-loader">
          <div className="bs-loader__spinner" />
          <p>{lang === "EN" ? "Loading Best Sellers..." : "جاري تحميل الأكثر مبيعاً..."}</p>
        </div>
      </div>
    );
  }

  if (error || !products?.length) {
    return (
      <div className="bs-slider bs-slider--empty" style={{ backgroundImage: "url('/assets/yellow background.jpg')" }}>
        <p>{lang === "EN" ? "No best sellers available" : "لا توجد منتجات متاحة"}</p>
      </div>
    );
  }

  // ─── Render ───────────────────────────────────────────
  return (
    <div className="bs-slider" style={{ backgroundImage: "url('/assets/yellow background.jpg')" }}>

      <div className="bs-slider__header">
        <TrendingUp size={28} className="bs-slider__icon" />
        <h2 className="bs-slider__title">
          {lang === "EN" ? "Top Most Sold" : "المنتجات الأكثر مبيعاً"}
        </h2>
        <Trophy size={28} className="bs-slider__icon" />
      </div>

      <div className="bs-slider__stage">
        <button
          className={`bs-slider__arrow bs-slider__arrow--left${canScrollLeft ? " is-visible" : ""}`}
          onClick={() => scroll("left")}
          aria-label={lang === "EN" ? "Previous" : "السابق"}
        >
          <ChevronLeft size={22} strokeWidth={2.5} />
        </button>

        <div className="bs-slider__track" ref={containerRef}>
          {products.map((product, i) => (
            <ProductCard key={`bs-${product.id}-${i}`} product={product} />
          ))}
        </div>

        <button
          className={`bs-slider__arrow bs-slider__arrow--right${canScrollRight ? " is-visible" : ""}`}
          onClick={() => scroll("right")}
          aria-label={lang === "EN" ? "Next" : "التالي"}
        >
          <ChevronRight size={22} strokeWidth={2.5} />
        </button>
      </div>
    </div>
  );
};

export default BestSellingSlider;